import gql from 'graphql-tag';

export const toggleCancelEventMutation = gql`
  mutation toggleCancelEvent($eventId: String!) {
    toggleCancelEvent(eventId: $eventId)
  }
`;
